module.exports = "/_next/static/images/content-badge-tier-0-8099a7e8f963768f9970798f604ebcc0.png";